import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const BusinessMail: Illustration = (props) => (
  <svg viewBox="0 0 162 190" {...illustrationProps(props, { width: 162 })}>
    <path
      d="m141.376 154.741-.218 11.182-.35 17.918-.077 4.087c-.035 1.689 2.594 1.689 2.629 0l.217-11.181.35-17.919.078-4.087c.035-1.689-2.594-1.689-2.629 0Z"
      fill="#FEA628"
    />
    <path
      d="m127.11 172.225 11.055.133 17.645.217 4.08.049c1.69.021 1.697-2.607 0-2.628l-11.055-.134-17.645-.217-4.08-.049c-1.689-.021-1.696 2.608 0 2.629Z"
      fill="#FEA628"
    />
    <path
      d="m153.23 158.106-8.062 7.754-12.919 12.422-2.945 2.832c-1.22 1.178.638 3.035 1.858 1.858l8.062-7.754 12.92-12.422 2.944-2.832c1.22-1.178-.638-3.035-1.858-1.858Z"
      fill="#FEA628"
    />
    <path
      d="m130.776 160.385 7.719 7.914 12.324 12.626 2.853 2.923c1.185 1.213 3.042-.645 1.858-1.858l-7.719-7.914-12.324-12.626-2.853-2.923c-1.185-1.213-3.042.645-1.858 1.858Z"
      fill="#FEA628"
    />
    <path
      d="M60.21 154.071H4.834a2.811 2.811 0 0 0-2.811 2.811v29.506a2.812 2.812 0 0 0 2.811 2.812h55.374a2.812 2.812 0 0 0 2.811-2.812v-29.506a2.811 2.811 0 0 0-2.81-2.811Z"
      fill="#B8E682"
    />
    <path
      d="m.594 157.639 10.361 7.025 16.53 11.209 3.807 2.58c.364.245.96.245 1.325 0l10.649-7.059 16.964-11.238 3.877-2.566c1.402-.932.091-3.21-1.325-2.271l-10.648 7.059-16.965 11.238-3.877 2.566h1.325l-10.361-7.025-16.53-11.209-3.807-2.58c-1.402-.953-2.72 1.325-1.325 2.271Z"
      fill="#22AE00"
    />
    <path
      d="M103.709 53.268H48.335a2.811 2.811 0 0 0-2.811 2.811v29.506a2.811 2.811 0 0 0 2.811 2.812h55.374a2.81 2.81 0 0 0 2.811-2.812V56.08a2.81 2.81 0 0 0-2.811-2.81Z"
      fill="#FFDE9B"
    />
    <path
      d="m44.094 56.836 10.361 7.025 16.53 11.21 3.807 2.579c.364.245.96.245 1.325 0l10.648-7.06 16.965-11.237 3.877-2.566c1.402-.932.091-3.21-1.325-2.271l-10.648 7.06-16.965 11.237-3.877 2.566h1.325l-10.361-7.025-16.53-11.21-3.807-2.579c-1.402-.953-2.72 1.325-1.325 2.271Z"
      fill="#FEA628"
    />
    <path
      d="m131.059 148.991-55.367.042a2.812 2.812 0 0 1-2.818-2.811l-.021-29.499 27.319-19.643a5.797 5.797 0 0 1 6.792.021l26.885 19.58.021 29.499a2.812 2.812 0 0 1-2.811 2.818v-.007Z"
      fill="#97A1FF"
    />
    <path
      d="M103.053 136.394s-23.344-15.107-23.352-16.313l-.013-17.989c0-1.205.974-2.187 2.18-2.187l42.966-.028c1.205 0 2.187.975 2.187 2.18l.014 17.989c0 1.206-23.989 16.348-23.989 16.348h.007Z"
      fill="#BEC4FF"
    />
    <path
      d="m72.831 118.153 9.899 6.793 15.78 10.831 3.617 2.488c.365.253.961.239 1.325 0l10.649-7.059 16.965-11.237 3.876-2.566c1.402-.932.091-3.211-1.325-2.271l-10.648 7.059-16.965 11.237-3.877 2.566h1.325l-9.898-6.793-15.78-10.831-3.618-2.488c-1.395-.961-2.713 1.318-1.325 2.271Z"
      fill="#4D5BE0"
    />
    <path
      d="m110.945 189.058-27.557-.544c-1.994-.048-3.567-1.714-3.519-3.725l-.147-16.657 13.373-13.329 18.246.202c1.993.049 3.567 1.715 3.518 3.726l-.22 26.775c-.049 2.011-1.701 3.6-3.694 3.552Z"
      fill="#FFC7C7"
    />
    <path
      d="m88.097 168.364-8.375-.232 13.371-13.329-.216 8.957c-.062 2.607-2.2 4.667-4.78 4.604Z"
      fill="#FF9494"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.045 4.682c-.939.865-1.633 2.22-1.633 4.212v21.75c0 1.404.39 2.248.812 2.718.418.466.957.67 1.507.655 1.08-.028 2.389-.949 2.389-2.985 0-1.133.01-2.802.02-4.697.029-4.672.065-10.721-.02-13.517a1.336 1.336 0 1 1 2.671-.08c.087 2.847.05 9.013.022 13.7-.011 1.867-.021 3.5-.021 4.595 0 3.4-2.381 5.587-4.99 5.656a4.59 4.59 0 0 1-3.567-1.542c-.962-1.071-1.495-2.606-1.495-4.503V8.894c0-2.669.957-4.76 2.494-6.177C73.75 1.32 75.737.664 77.68.664c1.94 0 3.915.654 5.423 1.985C84.635 4 85.618 5.995 85.618 8.505v22.916c0 4.075-1.287 7.182-3.367 9.253-2.071 2.062-4.82 2.986-7.53 2.895-5.434-.181-10.807-4.447-10.807-11.868V16.468a1.336 1.336 0 0 1 2.672 0V31.7c0 5.893 4.143 9.061 8.225 9.198 2.047.068 4.057-.628 5.554-2.118 1.489-1.483 2.58-3.861 2.58-7.36V8.505c0-1.761-.667-3.02-1.61-3.852-.968-.854-2.294-1.317-3.656-1.317-1.36 0-2.674.46-3.634 1.346Z"
      fill="#FF9494"
    />
    <path
      d="M17.09 109.974a4.66 4.66 0 0 1 4.66-4.661h37.286a4.661 4.661 0 0 1 4.66 4.661v15.536c0 12.87-10.433 23.303-23.303 23.303-12.87 0-23.304-10.433-23.304-23.303v-15.536Z"
      fill="#FFB3B3"
    />
    <path
      d="M19.808 113.858c-4.272-.777-12.817 0-12.817 10.593 0 8.05 9.322 10.38 13.206 8.827"
      stroke="#FF9494"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
  </svg>
);
